import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ArquivoAnexoModel } from '@shared/models/backend'
import { FileDownloaderService } from '../file-downloader/file-downloader.service'

@Component({
  selector: 'app-file-view',
  templateUrl: './file-view.component.html',
  styleUrls: ['./file-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileViewComponent {
  @Input()
  anexoModel: ArquivoAnexoModel
  /** Quando true, não aplica borda/box (útil quando o pai desenha um único retângulo para arquivo + ação). */
  @Input()
  noBorder = false

  constructor(private fileDownloaderService: FileDownloaderService) {}

  get title() {
    return this.anexoModel?.dsAnexo ? this.truncateText(this.anexoModel?.dsAnexo, 50) : ''
  }

  get titleTooltip() {
    return this.anexoModel?.dsAnexo?.length > this.title?.length ? this.anexoModel?.dsAnexo : ''
  }

  get arquivo() {
    return this.anexoModel?.arquivo
  }

  get filename() {
    return this.arquivo?.nome ? this.truncateFileName(this.arquivo?.nome, 30) : ''
  }

  download() {
    this.fileDownloaderService.download(this.arquivo)
  }

  private truncateText(text: string, len: number) {
    if (!text) {
      return text
    }
    if (text.length <= len) {
      return text
    }
    return text.substr(0, len).trim() + '...'
  }

  private truncateFileName(text: string, len: number) {
    if (!text) {
      return text
    }
    const ext = text.substring(text.lastIndexOf('.') + 1, text.length).toLowerCase()
    const filename = text.replace('.' + ext, '')
    if (filename.length <= len) {
      return text
    }
    return filename.substr(0, len).trim() + (text.length > len ? '...' : '') + '.' + ext
  }
}
